import { Link } from "react-router-dom";

interface Crumb {
  name: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.name} className="flex items-center gap-2">
              {index > 0 && <i className="ri-arrow-right-s-line text-foreground-300" />}
              {item.path && !isLast ? (
                <Link to={item.path} className="hover:text-primary-600 transition-colors">
                  {item.name}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800 font-medium" : ""}>{item.name}</span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}